import { useContext, useState } from 'react';

import { Grid } from 'types';

import { LayoutContext } from 'contexts';

import { IconName } from 'components/Icon';

import * as S from './GridButtons.styles';

type ButtonType = {
  id: number;
  icon: IconName;
  value: Grid;
};

const useGridButtons = () => {
  const [activeId, activeIdSet] = useState(1);

  const { gridSet } = useContext(LayoutContext);

  const data: ButtonType[] = [
    {
      id: 1,
      icon: 'FiLayout',
      value: 'layout',
    },
    {
      id: 2,
      icon: 'FiGrid',
      value: 'grid',
    },
    {
      id: 3,
      icon: 'BsGrid3X3Gap',
      value: 'grid2',
    },
  ];

  const pickLayoutTheme = (value: Grid, id: number) => {
    gridSet(value);
    activeIdSet(id);
  };

  const buttonsMapped = data?.map((item: ButtonType) => (
    <S.GridButton
      data-testid="button"
      isActive={activeId === item.id}
      key={item.id}
      motive="inlineRed"
      scale="lg"
      iconLeft={item.icon}
      onClick={() => pickLayoutTheme(item.value, item.id)}
    />
  ));

  return {
    buttonsMapped,
  };
};

export { useGridButtons };
